import objectsToArray from './objectsToArray';

export default function objectsToString(object: any) {
  return objectsToArray(object).join(' ');
}
